// Description: Individual toast with role, animation, close button, and pause-on-hover timer control

// Import React and hooks
import React, { useEffect, useRef, useState } from "react";



// Export the leaf component for a single toast
export default function Toast({ toast, onDismiss }) {


    // Destructure fields with defaults - timeout should be 4000
    const { id, title = "", message = "", apiErrorMessage = "", type = "info", autoCloseMs = 20000, canUserDismiss = true } = toast || {};

    // Local state for life-cycle animation stages
    const [stage, setStage] = useState("enter");

    // Ref to store remaining time for auto close when paused
    const remainingMsRef = useRef(autoCloseMs);

    // Ref to hold the start time of the current countdown tick
    const startedAtRef = useRef(Date.now());

    // Ref to hold the active timeout id so we can clear it
    const timeoutRef = useRef(null);

    // Compute ARIA role based on severity type
    const role = type === "error" || type === "warning" ? "alert" : "status";



    // Helper to start the timer
    const startTimer = () => {

        // Avoid timers when disabled
        if (!autoCloseMs || autoCloseMs <= 0) return;

        // Record the start timestamp for pause calculations
        startedAtRef.current = Date.now();

        // Clear any prior timeout
        clearTimeout(timeoutRef.current);

        // Set a new timeout for the remaining amount
        timeoutRef.current = setTimeout(() => handleClose(), remainingMsRef.current);

    };



    // Helper to pause the timer
    const pauseTimer = () => {

        // Skip when no auto close configured
        if (!autoCloseMs || autoCloseMs <= 0) return;

        // Clear the active timeout
        clearTimeout(timeoutRef.current);

        // Compute elapsed time since the timer started
        const elapsed = Date.now() - startedAtRef.current;

        // Reduce remaining time by elapsed duration but not below zero
        remainingMsRef.current = Math.max(0, remainingMsRef.current - elapsed);

    };



    // Helper to close with exit animation
    const handleClose = () => {

        // Begin exit stage so CSS plays the slide-down animation
        setStage("exit");

        // After the animation ends, call onDismiss to remove from context
        setTimeout(() => onDismiss?.(id), 180);

    };



    // Start timer on mount and cleanup on unmount
    useEffect(() => {

        // Start the auto close timer when component mounts
        startTimer();

        // On unmount, clear the timeout to avoid leaks
        return () => clearTimeout(timeoutRef.current);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // Render the toast card with BEM classes for variants and stage
    return (

        <div
            className={`toast toast--${type} toast--${stage}`}
            role={role}
            onMouseEnter={pauseTimer}
            onMouseLeave={startTimer}
        >

        {/* 
        <div className="toast__content">

            {title ? 
            
                <div className="toast__title">{title}</div>
            
            : null}

        <div className="toast__message">{message}</div>
        */}

        <div>

            <span className="toast__title">{title} </span> <span> {message}</span> <span className="toast__api-response"> {apiErrorMessage}</span>

        </div>

        {canUserDismiss && (

            <button className="toast__close" aria-label="Dismiss" onClick={handleClose}>×</button>

        )}

        </div>

    );

}